import { AnyAction } from '@reduxjs/toolkit';
import { OnboardingQuestionsService } from 'modules/OnboardingQuestion/service';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import {
	addQuestion,
	addQuestionFailure,
	addQuestionSuccess,
	deleteQuestion,
	deleteQuestionFailure,
	deleteQuestionSuccess,
	getAllQuestions,
	getAllQuestionsFailure,
	getAllQuestionsSuccess,
	getQuestionToUpdate,
	getQuestionToUpdateFailure,
	getQuestionToUpdateSuccess,
	updateQuestion,
	updateQuestionFailure,
	updateQuestionSuccess,
} from './slice';

function* getAllQuestionsListHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const questionService = new OnboardingQuestionsService(
			globalApplicationContext,
		);
		const data = yield questionService.getAllQuestions(action.payload.page);
		yield put(getAllQuestionsSuccess(data));
	} catch (e) {
		yield put(getAllQuestionsFailure(e));
		console.error(e);
	}
}

function* deleteQuestionHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const questionService = new OnboardingQuestionsService(
			globalApplicationContext,
		);
		yield questionService.deleteQuestion(action.payload.questionId);
		yield put(deleteQuestionSuccess({}));
		toast('Question deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteQuestionFailure(e));
		console.error(e);
	}
}

function* addQuestionHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const questionService = new OnboardingQuestionsService(
			globalApplicationContext,
		);
		yield questionService.addQuestion(action.payload);
		yield put(addQuestionSuccess({}));
		toast('Your question created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(addQuestionFailure({}));
	}
}

function* getQuestionToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const questionService = new OnboardingQuestionsService(
			globalApplicationContext,
		);
		const data = yield questionService.getQuestionById(
			action.payload.questionId,
		);
		yield put(getQuestionToUpdateSuccess(data));
	} catch (e) {
		yield put(getQuestionToUpdateFailure({}));
	}
}

function* updateQuestionHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const questionService = new OnboardingQuestionsService(
			globalApplicationContext,
		);
		yield questionService.updateQuestion(action.payload);
		yield put(updateQuestionSuccess({}));
		toast('Your question updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateQuestionFailure({}));
	}
}

export function* onboardingQuestionsSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getAllQuestions, getAllQuestionsListHandler),
		takeEvery(deleteQuestion, deleteQuestionHandler),
		takeEvery(addQuestion, addQuestionHandler),
		takeEvery(getQuestionToUpdate, getQuestionToUpdateHandler),
		takeEvery(updateQuestion, updateQuestionHandler),
	]);
}
